export default __webpack_public_path__ + "static/media/bug-line.fc262380.svg";